module.exports = __webpack_public_path__ + "img/8.1dd22e4f.png";